import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-bf51d164"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav-header" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h1", null, "CMS")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.image)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _ctx.image,
          alt: "Logo"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}